// extracted by mini-css-extract-plugin
export default {"menu":"ControlButtonMenu_menu__0c-5V","button":"ControlButtonMenu_button__LopX9"};